export const finalFormMutators = {
    setValue: ([field, value], state: any, { changeValue }: any) => {
        changeValue(state, field, () => value);
    },
};
